import { createSelector } from 'reselect'

const selectTest360State = (state: any) => state.test360

export const selectTest360Data = createSelector([selectTest360State], (test360State) => test360State.test360Data)

export const selectTest360Loading = createSelector([selectTest360State], (test360State) => test360State.loading)

export const selectTest360Error = createSelector([selectTest360State], (test360State) => test360State.error)

export const selectShowSummary = createSelector([selectTest360State], (test360State) => test360State.showSummary)

export const selectShowIntro = createSelector([selectTest360State], (test360State) => test360State.showIntro)

export const selectEvaluatedUsers = createSelector([selectTest360State], (test360State) => test360State.evaluatedUsers)

export const selectEvaluators = createSelector([selectTest360State], (test360State) => test360State.evaluators)

export const selectHas360Test = createSelector([selectTest360State], (test360State) => test360State.has360Test)

export const selectFinalDate = createSelector([selectTest360State], (test360State) => test360State.finalDate)

export const selectAnswers = createSelector([selectTest360State], (test360State) => test360State?.answers || {})

export const isTest360Selector = (state: any) => state.test360.has360Test

export const selectCompetenceAnswers = createSelector(
  [selectAnswers, (state: any, competenceId: number) => competenceId],
  (answers, competenceId) => answers[competenceId] || {}
)

export const selectQuestionAnswers = createSelector(
  [selectAnswers, (state: any, competenceId: number, questionIndex: number) => ({ competenceId, questionIndex })],
  (answers, { competenceId, questionIndex }) => answers[competenceId]?.[questionIndex] || {}
)

export const selectUserAnswer = createSelector(
  [
    selectAnswers,
    (state: any, competenceId: number, questionIndex: number, evaluatedUserId: string) => ({
      competenceId,
      questionIndex,
      evaluatedUserId,
    }),
  ],
  (answers, { competenceId, questionIndex, evaluatedUserId }) =>
    answers[competenceId]?.[questionIndex]?.[evaluatedUserId]
)

export const selectCompetenceProgress = createSelector(
  [selectAnswers, (state: any, competenceId: number, totalQuestions: number) => ({ competenceId, totalQuestions })],
  (answers, { competenceId, totalQuestions }) => {
    const competenceAnswers = answers[competenceId] || {}
    let answeredQuestions = 0

    for (let i = 0; i < totalQuestions; i++) {
      const questionAnswers = competenceAnswers[i] || {}
      if (Object.keys(questionAnswers).length > 0) {
        answeredQuestions++
      }
    }

    return {
      answeredQuestions,
      isCompleted: answeredQuestions === totalQuestions,
    }
  }
)

// New selectors for Test360 API data
export const selectTest360Competences = createSelector(
  [selectTest360State],
  (test360State) => test360State.competences || []
)

export const selectTest360EvaluatedUsers = createSelector(
  [selectTest360State],
  (test360State) => test360State.test360EvaluatedUsers || []
)

export const selectCompetenceById = createSelector(
  [selectTest360Competences, (state: any, competenceId: number) => competenceId],
  (competences: any[], competenceId: number) => competences.find((comp: any) => comp.competenceId === competenceId)
)

export const selectCompetencesProgress = createSelector([selectTest360Competences], (competences: any[]) => ({
  totalCount: competences.length,
  completedCount: competences.filter((comp: any) => comp.isComplete).length,
}))
